export const HOME_PAGE_PATH = '/'
export const SCHEDULE_PATH = '/program'
export const AUTHORS_PATH = '/autori'
export const DOCUMENTS_PATH = '/pro-ucastniky'
export const EDITION_PATH = '/rocnik/:uri'

export const generateEditionPath = (uri: string) =>
    EDITION_PATH.replace(':uri', uri)
